import axios from 'src/config/axios'
import axios2 from 'src/config/axios2'
import logo from 'src/api/logo'
import commonApi from 'src/api/common'

const UPLOAD_URL = 'https://upload.saasz.vdyoo.com/v2/upload_param'

export default {
  getBasicLogoInfo: ({ commit }) => {
    axios.get(commonApi.getBasicInfo, {
      params: {getAll: 1}
    }).then(response => {
      commit('SET_BASIC_LOGO_INFO', response)
    })
  },
  // 获取品牌Logo数据
  getLogoList: ({ commit }, param) => {
    // 去掉参数中的空值
    for (let key in param) {
      if (param[key] === '') {
        delete param[key]
      }
    }
    axios.post(logo.getLogoList,param,{methodType: 1}).then(response => {
      commit('SET_LOGO_LIST', response)
    })
  },
  uploadLogo: ({ dispatch, commit }, {file}) => {
    let appid = null
    let time = null
    let sign = null
    let keyMd5 = null
    if (
      process.env.MY_ENV === 'test' ||
      process.env.NODE_ENV === 'development'
    ) {
      appid = 1001060;
      time = Date.parse(new Date());
      keyMd5 = md5('51b4482f1466449c7c097d10b00e82e0' + '&' + time);
      sign = btoa(keyMd5 + '&' + time);
    } else {
      appid = 2001061;
      time = Date.parse(new Date());
      keyMd5 = md5('32c111af6231cbe04cb1943b5e9fef1b' + '&' + time);
      sign = btoa(keyMd5 + '&' + time);
    }
    let name = file.name
    let postfix = name.split('.')[name.split('.').length - 1]
    function guid() {
      function S4() {
        return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
      }
      return (S4() + S4() + S4() + S4() + S4() + S4() + S4() + S4());
    }
    let uuid = guid();
    let fileName = uuid + '.' + postfix
    let logoDirPath = `/XESlides/logo/${fileName}`
    // 获取token
    axios2.get(UPLOAD_URL,{
      params: {
        dst_path: logoDirPath, // 文件在云端的存储位置
        user_mark: 0,
        file_right: 0
      },
      methodType: 3,
      headers: {
        appid: appid,
        sign: sign
      }
    }).then((res) => {
      res.forEach(element => {
        if (element.type === 'OSS') {
          commit('SET_OSS_INFO', element)
          dispatch('putFile2OSS',{ ossInfo: element, file })
        }
      });
    })
  },
  // 把文件推到OSS
  putFile2OSS: ({commit}, {ossInfo, file}) => {
    axios2.put(ossInfo.host, file,
    {
      headers: ossInfo.request_header
    }).then((res) => {
      if (res === 'success') {
        commit('SET_LOGO_IMG', ossInfo.file_url)
        commit('SET_UPLOAD_STATE','success')
      } else {
        commit('SET_UPLOAD_STATE','fail')
        console.log('图片上传失败')
      }
    })
  },
  getLogoInfo: ({commit},id) => {
    axios.post(logo.getLogoInfo, {id}, {methodType: 1}).then(response => {
      commit('SET_LOGO_INFO', response)
    })
  },
  saveLogo: ({commit}, {logoForm, id}) => {
    let {checkedGrades, checkedSchools,name,pic,ratio,xAxes,yAxes} = logoForm
    let {width, height, path} = pic
    let form = {
      name,
      gradeIds: checkedGrades.join(','),
      schoolIds: checkedSchools.join(','),
      ratio,
      xAxes,
      yAxes,
      path,
      width,
      height
    }
    let url = logo.addLogo
    if (id) {
      url = logo.editLogo
      form.id = id
    }
    axios.post(url, form, {methodType: 1}).then(response => {
      if (response.status) {
        commit('SET_SAVE_LOGO_STATE','fail')
      } else {
        commit('SET_SAVE_LOGO_STATE','success')
      }
    })
  },
  changeLogoState: ({commit}, param) => {
    let {id, freeze, type} = param
    let data = {id, freeze}
    axios.post(logo.changeLogoState, data, {methodType: 1}).then(response => {
      if (response.indexOf('成功') !== -1) {
        commit('SET_CHANGE_LOGO_STATE',{type, msg: 'success'})
      } else {
        commit('SET_CHANGE_LOGO_STATE',{type, msg: 'fail'})
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/logo/actions.js